import React from "react";
import { Grid } from "@mui/material";
import { Alert, Box, CheckboxField } from "@curves/ui-base";
import { FieldGroup } from "@icoach/documents/components/Layout";
import { setCheckboxValue } from "@icoach/documents/tools";
import { SignBox } from "@icoach/components";
import { getErrorModuleStatus } from "@util/utils";
import { useMembershipSuspensionFormContext } from "@icoach/documents/membership/suspension/MembershipSuspensionFormContext";

const MembershipSuspensionNoticeSection = () => {
	const {
		formData,
		formRef,
		validationErrors,
		isReadOnly,
	} = useMembershipSuspensionFormContext();

	const {
		isConfirm,
		signImg,
		checkNextMembershipDebit,
		hasNewMembership,
	} = formData;

	return (
		<>
			<FieldGroup label="注意事項">
				<Grid item xs={12}>
					<Box component="ol" className="lists ol pl-3 mb-2">
						<Box component="li" className="lists-item pt-1">
							為配合銀行作業，會員須於暫停前最近一次扣款日之前十日辦理，暫停當月方可停扣月費，若辦理不及 則停扣作業將遞延，會員權益將不受影響。
						</Box>
						<Box component="li" className="lists-item">
							本文件辦理完畢後將直接生效，若有任何異動，仍需會員本人親自辦理。
						</Box>
					</Box>
					<Alert severity="info" variant="filled" color="info" className="alert-justify-content-start">
						暫停期間建議保持適度運動，相信妳了解持續運動帶給妳的好處，記得定時補充水份，保持正面心情，教練期待妳的歸隊！
					</Alert>
				</Grid>

				<Grid item xs={12}>
					<CheckboxField
						ref={el => (formRef.current.isConfirm = el)}
						defaultChecked={setCheckboxValue(isConfirm)}
						{...getErrorModuleStatus(validationErrors, "isConfirm")}
						readOnly={isReadOnly}
						required
					>
						<CheckboxField.Checkbox label="本人已瞭解、詳讀會員權暫停條款，並同意遵守。" />
					</CheckboxField>
				</Grid>

				{!isReadOnly && (
					<Grid item xs={6}>
						<SignBox
							ref={el => (formRef.current.signImg = el)}
							title="會員簽名"
							defaultValue={signImg}
							{...getErrorModuleStatus(validationErrors, "signImg")}
							readOnly={isReadOnly}
							required
						/>
					</Grid>
				)}
			</FieldGroup>

			{hasNewMembership && (
				<FieldGroup label="教練注意">
					<Grid item xs={12}>
						<Box style={{ marginTop: "-6px" }}>
							<CheckboxField
								ref={el => (formRef.current.checkNextMembershipDebit = el)}
								defaultChecked={setCheckboxValue(checkNextMembershipDebit)}
								{...getErrorModuleStatus(validationErrors, "keyName")}
								readOnly={isReadOnly}
								required
							>
								<CheckboxField.Checkbox label="暫停扣款日跨越新舊合約，新合約起始時將無法自動停扣，請留意需停扣月份，並自行手動刪除批次扣款訂單。" />
							</CheckboxField>
						</Box>
					</Grid>
				</FieldGroup>
			)}
		</>
	);
};

export default MembershipSuspensionNoticeSection;